import { useState } from 'react';
import { fmtUntil, turnSupportAccessOff, useSupportAccess } from '../utils/supportAccess';

// "Support access is on until 18:30 — Turn off", on every page while the
// customer has let Parvekshak support in (PRVSK-109). Turn off is offered to the
// people who can turn it on; everyone else just sees that it's on.
export default function SupportAccessBanner() {
  const [st] = useSupportAccess();
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  if (!st?.active) return null;

  const off = async () => {
    setBusy(true); setErr('');
    try { await turnSupportAccessOff(); }
    catch (e) { setErr(e.message); }
    finally { setBusy(false); }
  };

  return (
    <div role="status" style={{
      display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', flexShrink: 0,
      padding: '7px 16px', fontSize: 13, lineHeight: 1.4,
      background: '#fff8eb', color: '#7a4700', borderBottom: '1px solid #f0d49b',
    }}>
      🛟 Support access is on until {fmtUntil(st.until)}{st.allow_cameras ? ' (including cameras)' : ''}.
      {st.can_manage && (
        <button disabled={busy} onClick={off} style={{
          border: '1px solid currentColor', borderRadius: 6, padding: '3px 10px', fontSize: 12,
          fontWeight: 600, cursor: 'pointer', background: 'transparent', color: 'inherit',
        }}>{busy ? 'Turning off…' : 'Turn off'}</button>
      )}
      {err && <span style={{ color: '#b91c1c' }}>{err}</span>}
    </div>
  );
}
